import React, { useState, useEffect } from 'react';
import {
  Select,
  Text,
  Loader,
  Group
} from '@mantine/core';
import config from '../../../../config.js';
import useAuthenticatedData from '../../../../hooks/useAuthenticatedData';

const PurchasingUserSelect = ({ onUserSelect, defaultUserCode }) => {
  const [selectedUserCode, setSelectedUserCode] = useState('');

  // Custom hook to fetch authenticated data
  const { data: users, isLoading, error: fetchError } = useAuthenticatedData(
    `${config.apiBaseUrl}/supply-chain/purchasing/individual/users`
  );

  // Handle default user selection when data loads
  useEffect(() => {
    if (!isLoading && users && users.length > 0 && defaultUserCode) {
      const defaultUser = users.find(user => user.cCode === defaultUserCode);
      if (defaultUser) {
        setSelectedUserCode(defaultUserCode);
        onUserSelect(defaultUser);
      }
    }
  }, [users, isLoading, defaultUserCode, onUserSelect]);

  const handleUserChange = (selectedCode) => {
    setSelectedUserCode(selectedCode);

    const selectedUser = users?.find(user => user.cCode === selectedCode);
    if (selectedUser) {
      console.log('Selected user:', selectedUser);
      onUserSelect(selectedUser);
    }
  };

  if (isLoading) {
    return (
      <Group gap="xs">
        <Loader size="sm" />
        <Text size="sm">Loading users...</Text>
      </Group>
    );
  }

  if (fetchError) {
    return (
      <Text size="sm" c="red">
        Error: {fetchError}
      </Text>
    );
  }

  // Prepare data for Mantine Select
  const selectData = users?.map((user) => ({
    value: user.cCode,
    label: `${user.fullName} (${user.cCode})`
  })) || [];

  console.log('Select data:', selectData);

  return (
    <Select
      placeholder="Pick a purchasing user"
      value={selectedUserCode}
      onChange={handleUserChange}
      data={selectData}
      label="Select Purchasing User"
      style={{ 
        minWidth: 400
      }}
      clearable
    />
  );
};

export default PurchasingUserSelect;